module.exports = __webpack_public_path__ + "img/normal-status.e6a0f62d.svg";